import { action, computed, observable } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";
import moment from "moment";
import { RDDV2ItemModel } from "./RDDV2ItemModel";

export class RDDV2ItemViewModel extends ViewModelBase<RDDV2ItemModel> {
    constructor(item: RDDV2ItemModel) {
        super(item);
    }

    @observable
    public category: { id: string; displayName: string } | null = null;

    @computed
    public get id() {
        return this.model.id;
    }

    @computed
    public get rddV2CategoryId() {
        return this.model.rddV2CategoryId;
    }

    @computed
    public get latestResponseName() {
        return this.model.latestResponseName;
    }

    @computed
    public get latestResponseDateFormatted() {
        return this.model.latestResponseDate ? `${moment(this.model.latestResponseDate).format("DD/MM/YYYY")}` : "";
    }

    @computed
    public get categoryName() {
        return this.model.categoryName;
    }

    @computed
    public get supplierReference() {
        return this.model.supplierReference;
    }

    @computed
    public get clientReference() {
        return this.model.clientReference;
    }

    @computed
    public get supplierName() {
        return this.model.supplierName;
    }

    @computed
    public get title() {
        return this.model.title;
    }

    @computed
    public get description() {
        return this.model.description;
    }

    @computed
    public get requestedDate() {
        return this.model.requestedDate;
    }

    @computed
    public get requestedDateFormatted() {
        return this.model.requestedDate ? `${moment(this.model.requestedDate).format("DD/MM/YYYY")}` : "";
    }

    @computed
    public get requestedByName() {
        return this.model.requestedByName;
    }

    @computed
    public get requestedTo() {
        return this.model.requestedTo;
    }

    @computed
    public get responseRequiredByDateFormatted() {
        return this.model.responseRequiredByDate ? `${moment(this.model.responseRequiredByDate).format("DD/MM/YYYY")}` : "";
    }

    @computed
    public get numberOfFiles() {
        return this.model.numberOfFiles;
    }

    @computed
    public get statusName() {
        return this.model.statusName;
    }

    @computed
    public get statusId() {
        return this.model.rddV2StatusId;
    }

    @computed
    public get clientReferenceFormatted() {
        if (this.model.clientReference === null) {
            return "";
        } else if (this.model.clientReference === "0" || (this.model.clientReference === null && this.model.revision === null)) {
            return "";
        } else {
            if (this.model.revision === 0 || this.model.revision === null) {
                return "RDD" + this.model.clientReference;
            } else {
                return "RDD" + this.model.clientReference + "." + this.model.revision.toString();
            }
        }
    }

    @computed
    public get latestResponseFormatted() {
        return this.model.latestResponseName ? `${moment(this.model.latestResponseDate).format("DD/MM/YYYY @ HH:mm")} by ${this.model.latestResponseName}` : "";
    }

    @observable
    public issue: boolean = false;

    @action
    public toggleIssue = () => {
        this.issue = !this.issue;
    };

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public async isFieldValid(fieldName: keyof FieldType<RDDV2ItemModel>): Promise<boolean> {
        return true;
    }
}
